export default __webpack_public_path__ + "static/media/partner-werden.eb20bf54.svg";